<template>
    <div v-if="isPosition">
        <div class="positionFixed">
            <div class="masking" @click="clickPosPop"></div>
            <div class="tcCon">
                <div class="tcTit">
                    <span>{{$t('trade.products.closePosition')}}</span>
                </div>
                <div class="itemCon">
                    <div class="errInfo" v-if="errContent.length > 0">{{errContent[0]}}</div>
                    <div class="item1">
                        <p>{{$t("success.openingDirection")}}</p>
                        <span>{{position.Direction==1?$t('trade.products.buy'):$t('trade.products.sell')}}</span>
                    </div>
                    <div class="item1">
                        <p>{{$t("success.openingPrice")}}</p>
                        <span>{{position.OpenPrice}}</span>
                    </div>
                    <div class="item1">
                        <p>{{$t("success.executePrice")}}</p>
                        <span>{{closePrice}}</span>
                    </div>
                    <div class="item1">
                        <p>{{$t("trade.products.lot")}}<span v-if="position.symbolData" :class="errClass.volumeClass">({{position.symbolData.minVolumes < position.Volume?position.symbolData.minVolumes:position.Volume}}-{{position.Volume}})</span></p>
                        <div class="border">
                            <div :class="close.volume!='' && Number(close.volume) <= Number(position.symbolData.minVolumes)?'pic cut stop':'pic cut'" @click="changeVolume(1)"><img src="@/assets/images/template/a_chart_reduce.png"/></div>
                            <input v-if="position.symbolData.minVolumes < position.Volume" v-model="close.volume"/>
                            <input v-if="position.symbolData.minVolumes >= position.Volume" readonly v-model="close.volume"/>
                            <div :class="close.volume !='' && Number(close.volume) >= Number(position.Volume)?'pic add stop':'pic add'" @click="changeVolume(2)"><img src="@/assets/images/template/a_chart_increase.png"/></div>
                        </div>
                    </div>
                    <div class="item2">
                        <ul v-if="position.symbolData">
                            <li><p>{{$t('trade.products.available')}} $<Available></Available></p></li>
                            <li><p>{{$t('trade.products.floatProfitLoss')}} {{profit > 0?'+':'-'}}<em>${{Math.abs(profit)}}</em></p></li>
                        </ul>
                        <span @click="submit()" :class="errContent.length>0 || submitText==$t('message.submitting')?'err':''"><img v-if="submitText==$t('message.submitting')" src="@/assets/images/template/loading1.gif"/>{{submitText}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--提交失败提示-->
        <div class="popFixed" v-if="isError">
            <div class="masking" @click="errPop"></div>
            <div class="tcCon">
                <div class="item">
                    <p>{{errMessage}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="errPop">{{$t("message.definite")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import TradeUtil from '@/utils/tradeUtil'
    import Util from '@/utils/tradeDataUtil'
    import Constant from '@/utils/Constant'
    import Available from '@/view/module/Available.vue'

    export default {
        name: "PositionPop",
        components: {
            Available
        },
        props: ['position', 'code'],
        computed: {
            ...mapState(['tradeData', 'quote', 'account', 'socket', 'orderAddRet', 'positionUpdateRet','simpleResponse','group','dealAddRet']),
            /*平仓价格*/
            closePrice: {
                get() {
                    if (!this.position.SName || !this.quote.symbolTickMap[this.position.SName.szShortName]) return "";
                    return this.position.Direction == 1 ? this.quote.symbolTickMap[this.position.SName.szShortName].ask : this.quote.symbolTickMap[this.position.SName.szShortName].bid;
                }
            },
            /*盈亏*/
            profit: {
                get() {
                    if (this.position.symbolData) {
                        const ask = this.quote.symbolTickMap[this.position.SName.szShortName].ask;
                        const bid = this.quote.symbolTickMap[this.position.SName.szShortName].bid;
                        let sub = Util.accSub(this.closePrice, this.position.OpenPrice);
                        if (this.position.Direction == 2) sub = Util.accSub(this.position.OpenPrice, this.closePrice);
                        const profit = Util.accAdd(TradeUtil.changeCurrency(sub, ask, bid, this.close.volume || this.position.Volume, this.position.symbolData, this.quote.symbolTickMap, this.position.Direction), this.position.Swap);
                        return Number(profit).toFixed(2);
                    }
                    return "";
                }
            },
            errClass: {
                get() {
                    if (!this.position.symbolData) return {volumeClass: ""};
                    let volumeClass = "";
                    if (this.position.symbolData.minVolumes < this.position.Volume) {
                        volumeClass = this.close.volume != '' && (Number(this.close.volume) > Number(this.position.Volume) || Number(this.close.volume) < Number(this.position.symbolData.minVolumes)) ? 'err' : '';
                    }
                    return {
                        volumeClass: volumeClass,
                    }
                },
            },
            errContent: {
                get() {
                    let arr = [];
                    if (!this.position.symbolData) return [];
                    if (this.position.symbolData.minVolumes < this.position.Volume) {
                        if ((!this.close.amount || this.close.amount == '') || ((Number(this.close.amount) > Number(this.util.accMul(this.position.Volume , this.position.symbolData.marginInitial)) || Number(this.close.amount) < Number(this.util.accMul(this.position.symbolData.minVolumes , this.position.symbolData.marginInitial))))) arr.push(this.$t("message.modifyStopLoss.amountNoRange"));
                    }
                    return arr;
                },
            },
        },
        data() {
            return {
                tradeUtil:TradeUtil,
                util:Util,
                submitText: this.$t("message.definiteClosing"),
                isPosition: false,
                close: {volume: "",amount:""},
                oldClose: {},
                err: "",
                errMessage:'',
                isError:false,
            }
        },
        methods: {
            errPop(){
                this.isError=!this.isError;
            },
            clickPosPop() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                this.isPosition = !this.isPosition;
                const fix = String(this.position.symbolData.volumesStep).indexOf(".")>=0?String(this.position.symbolData.volumesStep).split(".")[1].length:0;
                this.close.volume = Number(this.position.Volume).toFixed(fix);
                this.close.amount = Util.accMul(this.close.volume , this.position.symbolData.marginInitial)
            },
            changeVolume(type) {
                const fix = String(this.position.symbolData.volumesStep).indexOf(".")>=0?String(this.position.symbolData.volumesStep).split(".")[1].length:0;
                if (this.close.volume == "") this.close.volume = this.position.symbolData.minVolumes;
                if (type == 1) {//减
                    const result = Number(Util.accSub(Number(this.close.volume), Number(this.position.symbolData.volumesStep))).toFixed(fix);
                    if (result >= this.position.symbolData.minVolumes) {
                        this.close.volume = Number(result).toFixed(fix);
                        this.close.amount = Util.accMul(this.close.volume, this.position.symbolData.marginInitial)
                    }
                } else {
                    const result = Number(Util.accAdd(Number(this.close.volume), Number(this.position.symbolData.volumesStep))).toFixed(fix);
                    if (result <= this.position.Volume) {
                        this.close.volume = Number(result).toFixed(fix);
                        this.close.amount = Util.accMul(this.close.volume, this.position.symbolData.marginInitial)
                    }
                }
            },
            submit() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                if (this.errContent.length > 0 || this.submitText == this.$t('message.submitting')) return;
                this.submitText = this.$t('message.submitting');
                let req = TradeUtil.getTradeReq(this.account, this.position.symbolData);//初始化请求对象
                req.MsgId = 1703;
                req.ExpireType = Constant.ExpireType.DAY;
                req.PositionID = this.position.ID;
                req.Type = Constant.OrderType.CLOSE;
                req.Direction = this.position.Direction == 1 ? 2 : 1;
                req.RequestVolume = this.close.volume;
                req.RequestPrice = this.closePrice;
                this.socket.tradeSocket.emit('request', Number(Constant.Req.openOrder), req);
            }
        },
        watch: {
            close: {
                //监听数据格式长度等
                deep: true,
                handler(newValue) {
                    //止损价控制
                    if (newValue.volume && newValue.volume != "") {
                        if (isNaN(newValue.volume) || String(newValue.volume).indexOf("e") >= 0 || String(newValue.volume).indexOf("-") >= 0) {
                            this.close.volume = this.oldClose.volume;
                            this.close.amount = Util.accMul(this.close.volume, this.position.symbolData.marginInitial)
                        } else if (String(newValue.volume).indexOf(".") > 0 && this.position.symbolData) {
                            const fix = String(this.position.symbolData.volumesStep).indexOf(".")>=0?String(this.position.symbolData.volumesStep).split(".")[1].length:0;
                            if (String(newValue.volume).split(".")[1].length > fix) {
                                this.close.volume = this.oldClose.volume;
                                this.close.amount = Util.accMul(this.close.volume, this.position.symbolData.marginInitial)
                            }
                        }
                    }
                    this.oldClose = TradeUtil.copy(this.close);
                },
            },
            simpleResponse: {
                //提交失败提示
                deep: true,
                handler(newValue, oldValue) {
                    this.submitText = this.$t("message.definiteClosing");
                    this.errMessage = this.tradeUtil.getFailMsg(newValue.Code,this.position.symbolData,this.group);
                    this.isError=!this.isError;
                    let mainH = document.getElementById("main");
                    mainH.classList.toggle('mainFixed');
                }
            },
            dealAddRet: {
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue.ID && this.position && newValue.PositionID == this.position.ID) {
                        if (this.orderAddRet.Type == Constant.OrderType.CLOSE) {
                            //平仓成功
                            let data = TradeUtil.copy(newValue);
                            this.isPosition = false;
                            this.submitText = this.$t("message.definiteClosing");
                            this.$router.replace({path: '/home/positionSuc',query:data})
                        }
                    }
                },
            },
        },
    }
</script>
